const LinkPermissions = {
  edit: 'link:edit',
  create: 'link:create',
  delete: 'link:delete',
  view: 'link:view',
}

export default LinkPermissions
